import { IconComponent } from './icon.component';
import { IconService } from './icon.service';
import iconSprite from './sprite';

export default angular
  .module('ng1-icon', [iconSprite])
  .component('icon', IconComponent)
  .service('iconService', IconService)
  .filter('trustedUrl', ($sce) => $sce.trustAsResourceUrl)
  .name;



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-icon/src/index.js